import { useState } from 'react'

export default function Alert ({ variant, children, toggleOut = false, onDismiss }) {
  const [show, setShow] = useState(true)

  if (toggleOut) {
    setTimeout(() => {
      setShow(false)

      if (onDismiss) {
        onDismiss()
      }
    }, 5000)
  }

  return (
    <>
      {show && (
      <div className={`alert alert-${variant}`}
        role="alert"
      >
        {children}
      </div>
      )}
    </>
  )
}
